type TTooltipEntry = {
  tooltip: string;
  tags: string[];
};

const productModelTooltips: Record<string, TTooltipEntry> = {
  casual: {
    tooltip:
      '休闲：面向休闲用户，玩法简单，主要靠内购收入并辅以少量广告。广告通常占每月总收入的25-30%。',
    tags: ['Casual', '休闲'],
  },
  exclusive_access: {
    tooltip:
      '特定权限：仅限外部订阅服务会员访问的游戏。这些游戏通常设计为提供与高级和精品游戏相似的功能和质量。',
    tags: ['Exclusive Access', '特定权限', 'Subscription-only Access'],
  },
  hybrid_casual: {
    tooltip:
      '混合休闲：结合休闲玩法与轻度中核养成。通常使用货币包、进程包、插页广告和奖励广告的组合来实现内容变现。广告通常占每月总收入的50%。',
    tags: ['Hybridcasual', 'Hybrid Casual', '混合休闲'],
  },
  hypercasual: {
    tooltip:
      '超休闲：低成本、短期高留存游戏，具有简单和重复的游戏机制。通常通过多个广告进行盈利，广告收入几乎占每月收入的100%。',
    tags: ['Hypercasual', 'Hyper Casual', '超休闲'],
  },
  mid_core: {
    tooltip:
      '中度：玩家为休闲和硬核游戏之间的中核玩家，玩法更深、进程更长，依靠长期留存和内购盈利。',
    tags: ['Mid-core', 'Midcore', '中度'],
  },
};

const sensorTagTooltips = {
  sensor_tower_tag_product_model: productModelTooltips,
};

export default sensorTagTooltips;
